<template>
  <div class="tags-view-wrap">
    <div :class="['tags-view-container', isScroll ? 'is-scroll' : '']">
      <span :class="['tags-view-prev']" v-if="isScroll" @click="scrollPrev">
        <i class="el-icon-arrow-left"></i>
      </span>
      <span :class="['tags-view-next']" v-if="isScroll" @click="scrollNext">
        <i class="el-icon-arrow-right"></i>
      </span>
      <div class="tags-view-scroll" ref="viewScroll">
        <div class="tags-view-list" ref="viewList" :style="tagsStyle">
          <router-link ref="tag" :class="['tags-view-item', isActive(tag) ? 'active' : '']" :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''" @contextmenu.prevent.native="openMenu(tag, $event)" v-for="tag in visitedViews" :key="tag.path">
            <span>{{ tag.title }}</span>
            <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
          </router-link>
        </div>
      </div>
    </div>
    <ul class="contextmenu" v-if="visible" :style="{ left: left + 'px', top: top + 'px' }">
      <li @click="refreshSelectedTag(selectedTag)">刷新页面</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)"><span>关闭当前</span> </li>
      <li @click="closeOthersTags"><span>关闭其他</span></li>
      <li v-if="!isFirstView()" @click="closeLeftTags">关闭左侧</li>
      <li v-if="!isLastView()" @click="closeRightTags">关闭右侧</li>
      <li @click="closeAllTags(selectedTag)"><span>全部关闭</span></li>
    </ul>
  </div>
</template>

<script>
import path from "path";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";

export default {
  name: "tagsView",
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      isScroll: true, // tags是否超出一行长度
      tagsViewOffset: 0,
    };
  },
  props: {},
  components: {},
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
    routes() {
      return this.$store.state.permission.routes;
    },
    tagsStyle() {
      return {
        transform: `translateX(-${this.tagsViewOffset}px)`,
      };
    },
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    addResizeListener(this.$el, this.updateTagsScroll);
    this.initTags();
    this.addTags();
  },
  methods: {
    generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },
    isFirstView() {
      try {
        return this.selectedTag.fullPath === this.visitedViews[1].fullPath || this.selectedTag.fullPath === '/'
      } catch (err) {
        return false
      }
    },
    isLastView() {
      try {
        return this.selectedTag.fullPath === this.visitedViews[this.visitedViews.length - 1].fullPath
      } catch (err) {
        return false
      }
    },
    // 右击打开菜单栏
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetTop = this.$el.getBoundingClientRect().top // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY - offsetTop
      this.visible = true
      this.selectedTag = tag
    },
    // 过滤固钉
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    // 初始化固钉
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    // 添加tags
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            const tagsList = this.$refs.viewList;
            const activeTab = this.$el.querySelector(".tags-view-item.active");
            if (!activeTab) return;
            const tagsScroll = this.$refs.viewScroll;
            const activeTabBounding = activeTab.getBoundingClientRect();
            const tagsScrollBounding = tagsScroll.getBoundingClientRect();
            const maxOffset = tagsList.offsetWidth - tagsScrollBounding.width;
            const currentOffset = this.tagsViewOffset;
            let newOffset = currentOffset;

            if (activeTabBounding.left < tagsScrollBounding.left) {
              newOffset =
                currentOffset -
                (tagsScrollBounding.left - activeTabBounding.left);
            }
            if (activeTabBounding.right > tagsScrollBounding.right) {
              newOffset =
                currentOffset +
                activeTabBounding.right -
                tagsScrollBounding.right;
            }

            newOffset = Math.max(newOffset, 0);
            this.tagsViewOffset = Math.min(newOffset, maxOffset);
            break;
          }
        }
      });
    },
    // 刷新当前
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    // 关闭当前
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    // 关闭右侧
    closeRightTags() {
      this.$store.dispatch('tagsView/delRightTags', this.selectedTag).then(visitedViews => {
        if (!visitedViews.find(i => i.fullPath === this.$route.fullPath)) {
          this.toLastView(visitedViews)
        }
      })
    },
    // 关闭左侧
    closeLeftTags() {
      this.$store.dispatch('tagsView/delLeftTags', this.selectedTag).then(visitedViews => {
        if (!visitedViews.find(i => i.fullPath === this.$route.fullPath)) {
          this.toLastView(visitedViews)
        }
      })
    },
    // 关闭其他
    closeOthersTags() {
      this.$router.push(this.selectedTag).catch(() => { });
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    // 关闭全部（除固钉）
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === this.$route.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    // 去最后一个tag
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    // 关闭菜单
    closeMenu() {
      this.visible = false;
    },
    // 前进
    scrollPrev() {
      const containerSize = this.$refs.viewScroll[`offsetWidth`];
      const currentOffset = this.tagsViewOffset;

      if (!currentOffset) return;

      let newOffset =
        currentOffset > containerSize ? currentOffset - containerSize : 0;
      this.tagsViewOffset = newOffset;
    },
    // 向后
    scrollNext() {
      const tagsSize = this.$refs.viewList[`offsetWidth`];
      const containerSize = this.$refs.viewScroll[`offsetWidth`];
      const currentOffset = this.tagsViewOffset;

      if (tagsSize - currentOffset <= containerSize) return;

      let newOffset =
        tagsSize - currentOffset > containerSize * 2
          ? currentOffset + containerSize
          : tagsSize - containerSize;
      this.tagsViewOffset = newOffset;
    },
    // 更新左右箭头是否显示
    updateTagsScroll() {
      if (!this.$refs.viewList) return;
      const tagsList = this.$refs.viewList[`offsetWidth`];
      const containerSize = this.$refs.viewScroll[`offsetWidth`];
      const currentOffset = this.tagsViewOffset;
      if (containerSize < tagsList) {
        const currentOffset = this.tagsViewOffset;
        this.isScroll = this.isScroll || { prev: false, next: false };
        // this.isScroll.prev = currentOffset;
        // this.isScroll.next = currentOffset + containerSize < tagsList;
        if (tagsList - currentOffset < containerSize) {
          this.tagsViewOffset = tagsList - containerSize;
        }
      } else {
        this.isScroll = false;
        if (currentOffset > 0) {
          this.tagsViewOffset = 0;
        }
      }
    },
  },
  updated() {
    this.updateTagsScroll();
  },
  beforeDestroy() {
    if (this.$el && this.updateTagsScroll)
      removeResizeListener(this.$el, this.updateTagsScroll);
  },
};
</script>

<style lang="less">
.tags-view-wrap {
  width: 100%;
  height: 34px;
  line-height: 32px;
  box-sizing: border-box;
  padding: 0 14px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  position: relative;
  .tags-view-container {
    height: 100%;
    position: relative;
    &.is-scroll {
      padding: 0 20px;
    }
    .is-disabled {
      color: #e8e8e8;
    }
    .tags-view-prev,
    .tags-view-next {
      position: absolute;
      height: 100%;
      font-size: 12px;
      cursor: pointer;
    }
    .tags-view-prev {
      left: 0;
    }
    .tags-view-next {
      right: 0;
    }
  }
  .tags-view-scroll {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .tags-view-list {
      line-height: 32px;
      white-space: nowrap;
      float: left;
      position: relative;
      z-index: 2;
      transition: transform 0.3s;
      .tags-view-item {
        display: inline-block;
        height: 24px;
        line-height: 24px;
        padding: 0 8px;
        font-size: 12px;
        border: 1px solid #e8e8e8;
        color: #797979;
        position: relative;
        border-radius: 2px;
        & + .tags-view-item {
          margin-left: 6px;
        }
        &.active {
          border-color: @themeColor;
          background: @themeColor;
          color: #fff;
          padding-left: 20px;
          position: relative;
          &::before {
            position: absolute;
            top: calc(50% - 3px);
            left: 8px;
            width: 6px;
            height: 6px;
            background: #fff;
            border-radius: 50%;
            content: "";
            transition: none;
          }
        }
        .el-icon-close {
          margin-left: 8px;
          font-size: 12px;
        }
      }
    }
  }
  .contextmenu {
    min-width: 80px;
    margin: 0;
    background: #fff;
    z-index: 9999;
    position: absolute;
    padding: 4px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    li {
      margin: 0;
      padding: 5px 16px;
      line-height: 22px;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>